import { indexInputMode } from "@documalis/_const/const";
import { checkBoolean, decodeUtf8, getArray, getColorName, getField, getTypeBsk, get_bskLabel, returnEmpty, setEmptyArray } from "./tools.utils";

export interface atfActions {
    atfRenaming: string;
    atfAllowAddFile: boolean;
    atfAllowDelete: boolean;
    atfAllowRename: boolean;
    atfAllowPrefixList: boolean;
    atfAllowConvertPdf: boolean;
    atfAllowSaveAs: boolean;
}


export function setCurrentSelectedBsk(bsk, aApi) {
    let wBlockDoc = false;
    let wRequiredComment = false;
    let wApply = false;
    let wBskbuttonList = new Array();
    let wBskbutton: any;
    let wAllowActions = '';
    let wUsePreProcess = false;
    let wTypeDock = 'HorizontalButtons';
    let wPreProcessName = '';
    let wDuplicateDocument = false;
    let wBskParameterList = new Array();
    let wParameter: any;
    let wbskOrder = 'DateDes';
    let wIndexInputMode = indexInputMode[2];
    let wRestFormat = {
        pdf: false,
        tiff: false,
        picture: false,
        text: false,
        spreadSheet: false,
        presentation: false,
        email: false,
    };
    let wAtfActions: atfActions;

    if (!Array.isArray(bsk.Docks)) {
        wTypeDock = getTypeDock(bsk.Docks.DockStandard);
        wbskOrder = getBskOrder(bsk.Docks);
        wAtfActions = getAtfAction(bsk.Docks);
    }

    if (bsk.Restrictions) {
        if (!Array.isArray(bsk.Restrictions)) {
            wRestFormat.pdf = checkBoolean(bsk.Restrictions.Pdf);
            wRestFormat.tiff = checkBoolean(bsk.Restrictions.Tiff);
            wRestFormat.picture = checkBoolean(bsk.Restrictions.Picture);
            wRestFormat.text = checkBoolean(bsk.Restrictions.Text);
            wRestFormat.spreadSheet = checkBoolean(bsk.Restrictions.SpreadSheet);
            wRestFormat.presentation = checkBoolean(bsk.Restrictions.Presentation);
            wRestFormat.email = checkBoolean(bsk.Restrictions.Email);
        }
    }

    switch (bsk.Information.basketType) {
        case 'btMail': {
            wAllowActions = getAllowActions(bsk);
            wIndexInputMode = getIndexInputMode(bsk.Declaration);
            wDuplicateDocument = getAllowDuplicate(bsk);
            wApply = true;
            break;
        }
        case 'btCollect': {
            wBlockDoc = checkBoolean(bsk.Declaration.BlockDoc);
            wIndexInputMode = getIndexInputMode(bsk.Declaration);
            wRequiredComment = checkBoolean(bsk.Declaration.RequiredComment);
            wAllowActions = getAllowActions(bsk);
            wDuplicateDocument = getAllowDuplicate(bsk);
            wApply = getMoving(bsk);
            wUsePreProcess = checkBoolean(bsk.PreProcess.UsePreProcess);
            if (wUsePreProcess) {
                wPreProcessName = bsk.PreProcess.PreProcessName;
                if (bsk.PreProcess.ParameterList.length !== 0) {
                    bsk.PreProcess.ParameterList.Parameter.map((item) => {
                        wParameter = new Object();
                        wParameter.Name = getField(item.Name);
                        wParameter.Value = getField(item.Value);
                        wBskParameterList.push(wParameter);
                    });
                }
            }
            break;
        }
        case 'btPublish': {
            wIndexInputMode = indexInputMode[0];
            wBlockDoc = !checkBoolean(bsk.Scenario.BlockDoc);
            wRequiredComment = checkBoolean(bsk.Scenario.RequiredComment);
            wAllowActions = getAllowActions(bsk);
            wDuplicateDocument = getAllowDuplicate(bsk);
            wApply = true;
            break;
        }
        case 'btAction': {
            wIndexInputMode = getIndexInputMode(bsk.Declaration);
            bsk.General.ButtonList.Button.map((item, index) => {
                wBskbutton = new Object();
                wBskbutton.Label = getField(item.Label);
                wBskbutton.RequiredComment = checkBoolean(item.RequiredComment);
                wBskbutton.NoVariablesRequired = checkBoolean(item.NoVariablesRequired);
                if (aApi !== null) {
                    wBskbutton.url = getUrlBtnBsk(item.Picture, index +1, aApi);
                }
                wBskbuttonList.push(wBskbutton);
            });
            break;
        }
        case 'btInput': {
            wIndexInputMode = getIndexInputMode(bsk.CheckDocument);
            wBlockDoc = checkBoolean(bsk.CheckDocument.BlockDoc);
            wRequiredComment = checkBoolean(bsk.CheckDocument.RequiredComment);
            wAllowActions = getAllowActions(bsk);
            wDuplicateDocument = getAllowDuplicate(bsk);
            wApply = true;
            break;
        }
        case 'btOutput': {
            wIndexInputMode = getIndexInputMode(bsk.Declaration);
            wBlockDoc = checkBoolean(bsk.CheckDocument.BlockDoc);
            wRequiredComment = checkBoolean(bsk.CheckDocument.RequiredComment);
            wAllowActions = '';
            wApply = getMoving(bsk);
            break;
        }
        case 'btSystem': {
            wIndexInputMode = getIndexInputMode(bsk.Declaration);
            wApply = false;
            break;
        }
    }
    return {
        bskLabel: bsk.Information.Label,
        bskName: bsk.Information.Name,
        bskType: bsk.Information.basketType,
        bskTypeSearch: getTypeBsk(bsk.Information.basketType),
        bskAllowActions: wAllowActions,
        bskBlockDoc: wBlockDoc,
        bskRequiredComment: wRequiredComment,
        bskApply: wApply,
        bskbuttonList: wBskbuttonList,
        pdfStampList: getStampList(bsk),
        pdfSignPicture: checkBoolean(bsk.Actions.SignPicture),
        pdfSignCertificate: checkBoolean(bsk.Actions.SignCertificate),
        bskDockDyn: bsk.Docks.DynamicDockList,
        bskTypeDock: wTypeDock,
        bskUsePreProcess: wUsePreProcess,
        bskPreProcessName: wPreProcessName,
        bskParameterList: wBskParameterList,
        bskOrder: wbskOrder,
        bskRights: getBskRigths(bsk.Docks, bsk.Actions),
        bskPdfView: checkBoolean(bsk.Docks.PdfView),
        bskMaxShowDoc: bsk.Docks.MaxShowDocuments,
        bskModeAutoLock: checkBoolean(bsk.Docks.ModeAutoLocking),
        bskUpdateAfterVal: checkBoolean(bsk.Docks.UpdateAfterValidationIfEmpty),
        bskRestFormat: wRestFormat,
        bskIndexInputMode: wIndexInputMode,
        bskAtfActions: wAtfActions,
        bskAllowSetRvf: checkBoolean(bsk.Docks.AllowSetRvf),
        bskAllowCreateVersion: checkBoolean(bsk.Docks.CreateVersion),
        bskDuplicateDocument: wDuplicateDocument,
        bskComposition: checkBoolean(bsk.Docks.Composition),
    };
}

export function storeBaskets(aData, aApi, aUser) {
    let wBskList: any;
    wBskList = getBaskets(aData, null, false, [], [], aApi, []);
    return setStoreBsk(aUser, wBskList, aApi);
}


export function setStoreBsk(aPref, aBskList, aApi) {
    let wBasketList = new Array();
    let wBskList = new Array();
    wBasketList = addInfosBsk(aBskList.wBasketMailList, 'btMail', null, null, aApi, null, null, null);    
    wBskList.push({ id: 'BasketMailList' + aPref, value: {BasketMail: wBasketList} });

    wBasketList = [];    
    wBasketList = addInfosBsk(aBskList.wBasketCollectList, 'btCollect', null, null, aApi, null, null, null);
    wBskList.push({ id: 'BasketCollectList' + aPref, value: {BasketCollect: wBasketList}});    

    wBasketList = [];    
    wBasketList = addInfosBsk(aBskList.wBasketPublishList, 'btPublish', null, null, aApi, null, null, null);
    wBskList.push({ id: 'BasketPublishList' + aPref, value: {BasketPublish: wBasketList}});    

    wBasketList = [];    
    wBasketList = addInfosBsk(aBskList.wBasketActionList, 'btAction', null, null, aApi, null, null, null);
    wBskList.push({ id: 'BasketActionList' + aPref, value: {BasketAction: wBasketList}});   

    wBasketList = [];    
    wBasketList = addInfosBsk(aBskList.wBasketInputList, 'btInput', null, null, aApi, null, null, null);
    wBskList.push({ id: 'BasketInputList' + aPref, value: {BasketInput: wBasketList}});   

    wBasketList = [];    
    wBasketList = addInfosBsk(aBskList.wBasketOutputList, 'btOutput', null, null, aApi, null, null, null);
    wBskList.push({ id: 'BasketOutputList' + aPref, value: {BasketOutput: wBasketList}});   

    wBasketList = [];    
    wBasketList = addInfosBsk(aBskList.wBasketSystemList, 'btSystem', null, null, aApi, null, null, null);                
    wBskList.push({ id: 'BasketSystemList' + aPref, value: {BasketSystem: wBasketList}});   
    return wBskList;   
}


export function getBaskets(aData, aInfo, aFromGed, aListTag, aUserBskFilter, aApi, aDockDynList) {
    let wBasketMailList = new Array();
    let wBasketCollectList = new Array();
    let wBasketPublishList = new Array();
    let wBasketActionList = new Array();
    let wBasketInputList = new Array();
    let wBasketOutputList = new Array();
    let wBasketSystemList = new Array();

    wBasketMailList = prepareBasketList(aData, 'BasketMailList', 'BasketMail');
    wBasketCollectList = prepareBasketList(aData, 'BasketCollectList', 'BasketCollect');
    wBasketPublishList = prepareBasketList(aData, 'BasketPublishList', 'BasketPublish');
    wBasketActionList = prepareBasketList(aData, 'BasketActionList', 'BasketAction');
    wBasketInputList = prepareBasketList(aData, 'BasketInputList', 'BasketInput');
    wBasketOutputList = prepareBasketList(aData, 'BasketOutputList', 'BasketOutput');
    wBasketSystemList = prepareBasketList(aData, 'BasketSystemList', 'BasketSystem');

    if (aFromGed) {
        wBasketMailList = filterGed(wBasketMailList);
        wBasketCollectList = filterGed(wBasketCollectList);
        wBasketPublishList = filterGed(wBasketPublishList);
        wBasketActionList = filterGed(wBasketActionList);
        wBasketInputList = filterGed(wBasketInputList);
        wBasketOutputList = filterGed(wBasketOutputList);
        wBasketSystemList = filterGed(wBasketSystemList);
    }
    wBasketMailList = addInfosBsk(wBasketMailList, 'btMail', aInfo, aListTag, aApi, aUserBskFilter, false, aDockDynList);
    wBasketCollectList = addInfosBsk(wBasketCollectList, 'btCollect', aInfo, aListTag, aApi, aUserBskFilter, false, aDockDynList);
    wBasketPublishList = addInfosBsk(wBasketPublishList, 'btPublish', aInfo, aListTag, aApi, aUserBskFilter, false, aDockDynList);
    wBasketActionList = addInfosBsk(wBasketActionList, 'btAction', aInfo, aListTag, aApi, aUserBskFilter, false, aDockDynList);
    wBasketInputList = addInfosBsk(wBasketInputList, 'btInput', aInfo, aListTag, aApi, aUserBskFilter, false, aDockDynList);
    wBasketOutputList = addInfosBsk(wBasketOutputList, 'btOutput', aInfo, aListTag, aApi, aUserBskFilter, false, aDockDynList);
    wBasketSystemList = addInfosBsk(wBasketSystemList, 'btSystem', aInfo, aListTag, aApi, aUserBskFilter, false, aDockDynList);
    return {
        wBasketMailList,
        wBasketCollectList,
        wBasketPublishList,
        wBasketActionList,
        wBasketInputList,
        wBasketOutputList,
        wBasketSystemList,
    };
}

export function prepareBasketList(aData, aList, aName) {
    aData[aList] = setEmptyArray(aData[aList]);
    return getArray(aData[aList][aName]);
}

export function filterGed(aBasketList) {
    return (aBasketList = aBasketList.filter((item) => {
        if (item.UserBasket) {
            if (!Array.isArray(item.UserBasket)) {
                return item.UserBasket.Ged === 'true';
            }
        }
    }));
}

export function getTypeDock(aData) {
    let wRes = 'HorizontalButtons';
    if (aData) {
        if (!Array.isArray(aData)) {
            wRes = aData;
        }
    }
    return wRes;
}

export function getBskOrder(aData) {
    let wRes = 'DateDes';
    if (!Array.isArray(aData.DocumentOrder)) {
        wRes = aData.DocumentOrder;
    }
    return wRes;
}

export function getAtfAction(aDocks) {
    let wAtfRenaming;
    wAtfRenaming = returnEmpty(aDocks.AtfRenaming);
    if (Array.isArray(wAtfRenaming)) {
        wAtfRenaming = '';
    }
    return {
        atfRenaming: wAtfRenaming,
        atfAllowAddFile: aDocks.AtfAllowAddFile === undefined ? true : checkBoolean(aDocks.AtfAllowAddFile),
        atfAllowDelete: aDocks.AtfAllowDelete === undefined ? true : checkBoolean(aDocks.AtfAllowDelete),
        atfAllowRename: aDocks.AtfAllowRename === undefined ? true : checkBoolean(aDocks.AtfAllowRename),
        atfAllowPrefixList: aDocks.AtfAllowPrefixList === undefined ? true : checkBoolean(aDocks.AtfAllowPrefixList),
        atfAllowConvertPdf: aDocks.AtfAllowConvertPdf === undefined ? true : checkBoolean(aDocks.AtfAllowConvertPdf),
        atfAllowSaveAs: aDocks.AtfAllowSaveAs === undefined ? true : checkBoolean(aDocks.AtfAllowSaveAs),
    };
}

export function getAllowActions(aBsk) {
    let wRes = 'CopyMove';
    if (aBsk !== undefined) {
        if (aBsk.UserBasket !== undefined) {
            if (aBsk.UserBasket.AllowActions !== undefined) {
                wRes = aBsk.UserBasket.AllowActions;
            }
        }
    }
    return wRes;
}

export function getIndexInputMode(aBsk) {
    let wRes = indexInputMode[2];
    if (aBsk !== undefined) {
        if (aBsk.IndexInputMode !== undefined) {
            if (indexInputMode.indexOf(aBsk.IndexInputMode) !== -1) {
                wRes = aBsk.IndexInputMode;
            }
        }
    }
    return wRes;
}

export function getAllowDuplicate(aBsk) {
    let wRes = false;
    if (aBsk !== undefined) {
        if (aBsk.UserBasket !== undefined) {
            if (aBsk.UserBasket.DuplicateDocument !== undefined) {
                wRes = checkBoolean(aBsk.UserBasket.DuplicateDocument);
            }
        }
    }
    return wRes;
}

export function getMoving(absk) {
    let wRes = false;
    if (Array.isArray(absk.Moving.BasketList)) {
        if (absk.Moving.BasketList.length !== 0) {
            wRes = true;
        }
    } else {
        if (absk.Moving.BasketList !== '') {
            wRes = true;
        }
    }
    return wRes;
}

export function getUrlBtnBsk(aPicture, aIndex, aApi) {
    if (Array.isArray(aPicture)) {
        return aApi.execGetUrlGedAction('getimgbskdef', 'action_action_bt' + aIndex);        
    } else {
        return aApi.execGetUrlGedAction('getimgbtnbsk', aPicture);
    }
}

export function getStampList(bsk) {
    let wStampList = new Array();
    let wStamp: any;
    if (bsk.Actions.StampList) {
        if (!Array.isArray(bsk.Actions.StampList)) {
            if (bsk.Actions.StampList.length !== 0) {
                bsk.Actions.StampList.Stamp.map((item) => {
                    wStamp = new Object();
                    if (checkBoolean(item.Active) === true) {
                        wStamp.Active = true;
                        wStamp.Text = getField(item.Text);
                        wStamp.Variable = getField(item.Variable);
                        wStamp.Color = getField(item.Color);
                        wStamp.Size = getField(item.Size);
                    } else {
                        wStamp.Active = false;
                        wStamp.Text = '';
                        wStamp.Variable = '';
                    }
                    wStampList.push(wStamp);
                });
            }
        }
    }
    return wStampList;
}

export function getBskRigths(aDocks, aActions) {
    return {
        TDVar: checkBoolean(aDocks.Variables),
        TDCom: checkBoolean(aDocks.Comments),
        TAddCom: checkBoolean(aDocks.Comments),
        TDTra: checkBoolean(aDocks.Traces),
        TDAft: checkBoolean(aDocks.Attachments),
        TDel: checkBoolean(aDocks.AllowDestroy),
        TSign: checkBoolean(aActions.SignPicture) || checkBoolean(aActions.SignCertificate),
        TPost: checkBoolean(aActions.Comment),
        TGViewPdf: checkBoolean(aDocks.PdfView),
        TDInfo: checkBoolean(aDocks.Information),
    };
}

export function addInfosBsk(aData, aBskType, aListCount, aListTag, api, aUserBskFilter, aDisabled = false, aDockDynList) {
    if (aData === undefined) {
        return null;
    }
    let i = 0;
    let wName;
    let wGradGauge;
    let wDragDrop = {
        DragDrop: 'false',
    };
    let wUserBasket = {
        DragDrop: 'false',
    };
    let wDocks = [];
    aData = aData.map((item) => {
        wName = decodeUtf8(item.Information.Name);
        item.Information.Name = wName;
        item.Information.index = i;
        item.Information.url = getUrlImgBsk(wName, aBskType, item.Information.Picture, api);
        item.Information.defUrl = getBskPictureDef(wName, aBskType, api);
        item.Information.color = getColorName(wName);
        item.Information.isSelected = false;
        item.Information.docCount = getListCount(aListCount, wName);
        wGradGauge = getGradient_gauge(item);
        item.Information.gauge = wGradGauge.gauge;
        item.Information.Gradient = wGradGauge.gradient;

        item.Information.progressColor = getValueColor(item.Information.docCount, item.Information.Gradient);
        item.Information.maxValue = getMaxValue(item.Information.docCount, item.Information.Gradient);

        item.Information.basketType = aBskType;
        item.Information.filterBsk = getFilterBsk(aUserBskFilter, wName);

        if (!item.UserBasket) {
            item.UserBasket = wUserBasket;
        } else {
            if (Array.isArray(item.UserBasket)) {
                item.UserBasket = wDragDrop;
            }
        }
        item.Information.Label = get_bskLabel(item, wName);
        item.Information.Description = getField(item.Information.Description);
        item.tag = getListTag(aListTag, wName);
        item.disabledBsk = aDisabled;
        wDocks = getDocks(aDockDynList, wName);
        item.Docks.DynamicDockList = wDocks;
        i++;
        return item;
    });
    return aData;
}

export function getDocks(aDockDynList, aName) {
    let wDocks = [];
    if (aDockDynList !== null) {
        for (let i = 0; i < aDockDynList.length; i++) {
            if (aDockDynList[i].bskname === aName) {
                wDocks.push({ label: aDockDynList[i].label, name: aDockDynList[i].name })
            }
        }
    }
    return wDocks;
}

export function getFilterBsk(aUserBskFilter, aName) {
    let wFilterBsk = false;
    if (aUserBskFilter !== null) {
        for (let i = 0; i < aUserBskFilter.length; i++) {
            if (aUserBskFilter[i].bskname === aName) {
                if (aUserBskFilter[i].filterauto === 1) {
                    wFilterBsk = true;
                    break;
                }
            }
        }
    }
    return wFilterBsk;
}

export function getListTag(aListTag, aName) {
    let wTag = [];
    if (aListTag !== null) {
        for (let j = 0; j < aListTag.length; j++) {
            if (aListTag[j].bskname === aName) {
                wTag.push(aListTag[j].name);
            }
        }
    }
    return wTag;
}


export function getListCount(aListCount, aName) {
    let wCount = 0;
    if (aListCount !== null && aListCount.length !==0) {
        if (aListCount[aName] !== undefined) {
            wCount = aListCount[aName];
        }
    }
    return wCount;
}

export function getGradient_gauge(item) {
    let wGradient = 10;
    let wGauge = 0;
    wGradient = getGradient(item.Information.Gradient);
    if (item.Information.docCount === wGradient) {
        wGauge = 100;
    } else {
        wGauge = getGauge(Math.ceil((item.Information.docCount / wGradient) * 9));
    }
    return {
        gradient: wGradient,
        gauge: wGauge
    }
}

export function getGauge(aValue) {
    if (aValue < 10) {
        return aValue * 10;
    } else {
        return 100;
    }
}

export function getGradient(aData) {
    let wRes = 10;
    if (!Array.isArray(aData)) {
        if (!isNaN(aData)) {
            wRes = Number(aData);
        }
    }
    return wRes;
}

export function getUrlImgBsk(aName, aBskType, aPicture, aApi) {
    if (Array.isArray(aPicture)) {
        return getBskPictureDef(aName, aBskType, aApi);
    } else {
        return aApi.execGetUrlGedAction('getimgbskcust', aPicture);
    }
}

export function getBskPictureDef(aname, abskType, aApi) {
    switch (abskType) {
        case 'btMail':
            return aApi.execGetUrlGedAction('getimgbskdef', 'basket_mail');
        case 'btCollect':
            return aApi.execGetUrlGedAction('getimgbskdef', 'basket_collect');
        case 'btPublish':
            return aApi.execGetUrlGedAction('getimgbskdef', 'basket_publish');
        case 'btAction':
            return aApi.execGetUrlGedAction('getimgbskdef', 'basket_action');
        case 'btInput':
            return aApi.execGetUrlGedAction('getimgbskdef', 'basket_input');
        case 'btOutput':
            return aApi.execGetUrlGedAction('getimgbskdef', 'basket_output');
        case 'btSystem': {
            switch (aname) {
                case 'Deleted':
                    return aApi.execGetUrlGedAction('getimgbskdef', 'basket_deleted');
                case 'Distribution':
                    return aApi.execGetUrlGedAction('getimgbskdef', 'basket_distribution');
                case 'Error':
                    return aApi.execGetUrlGedAction('getimgbskdef', 'basket_error');
            }
        }
    }
}

export function getValueColor(docCount: number, gradient: number): string {
    const progress = (docCount * 100) / gradient;
    if (progress <= 25) {
        return 'green';
    } else if (progress <= 50) {
        return 'orangered';
    } else if (progress <= 75) {
        return 'brown';
    } else {
        return 'red';
    }
}

export function getMaxValue(docCount: number, gradient: number) {
    if (gradient > docCount) {
        return gradient;
    } else {
        return docCount;
    }
}